import { Text, TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
export const MobileDomainTaken = _ref => {
  let {
    domainName,
    action,
    datahook
  } = _ref;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.domain_taken",
    values: {
      domainName
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "thin"
    }), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: action
    })]
  }));
};
//# sourceMappingURL=MobileDomainTaken.js.map